import React, { useState } from "react";
import { Formik } from "formik";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Grid,
  Typography,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

import SequenceFieldForm from "./SequenceFieldForm";
import { useAxios, useComponent } from "../../../hooks";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";

export default function SetSequenceGroup({
  setGroups,
  popUp,
  setPopUp,
  sequence,
}) {
  const axios = useAxios();
  const { alert } = useComponent();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    sequence_fields: sequence,
  };

  const handleClose = () => {
    setPopUp(false);
  };

  return (
    <Dialog
      open={popUp}
      onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { minWidth: "600px" } }}
    >
      <Grid container spacing={0} sx={{ borderBottom: "1px solid #cbcbcb" }}>
        <Grid size={8} sx={{ p: "16px 24px" }}>
          <Typography variant="h5">Group Sequence</Typography>
        </Grid>
        <Grid size={4}>
          <IconButton
            onClick={handleClose}
            disableRipple
            sx={{ float: "right", p: "16px 24px" }}
          >
            <Cancel />
          </IconButton>
        </Grid>
      </Grid>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnMount
        onSubmit={async (formData, { setSubmitting }) => {
          setLoading(true);
          const sequenceData = {
            groupsSequence: formData.sequence_fields.map((seq, index) => ({
              group_id: seq.id,
              priority: index + 1,
            })),
          };

          try {
            const response = await axios({
              url: "/set/sequence",
              method: "POST",
              data: sequenceData,
              disableRedirect: true,
            });

            if (response.status) {
              setGroups(formData.sequence_fields);
              alert.success(response.message?.displayMessage);
            }
          } catch (error) {
            console.error(error);
          } finally {
            setSubmitting(false);
            setLoading(false);
            handleClose();
          }
        }}
      >
        {(dialogFormikProps) => (
          <>
            <DialogContent
              sx={{
                pt: 1,
                overflowY: "unset",
                backgroundColor: "#F7F9FC",
              }}
            >
              <Grid container spacing={4} sx={{ pt: 1 }}>
                <Grid size={12}>
                  <Typography variant="body1" color="text.secondary">
                    Drag and drop the card to set the sequence order of the
                    custom fields.
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <SequenceFieldForm
                    customFields={sequence}
                    dialogFormikProps={dialogFormikProps}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <CancelButton
                    variant="outlined"
                    color="primary"
                    onClick={handleClose}
                  >
                    Cancel
                  </CancelButton>
                </Grid>

                <Grid size />

                <Grid item>
                  <PrimaryLoadingButton
                    loading={loading}
                    onClick={dialogFormikProps.handleSubmit}
                    variant="contained"
                    color="primary"
                  >
                    Set Sequence
                  </PrimaryLoadingButton>
                </Grid>
              </Grid>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
}
